const ClaimProcessSteps = ({ lenderName }) => {
  return (
    <section
      className="py-12 md:py-16"
      style={{ backgroundColor: 'rgba(25, 135, 84, 0.1)' }}
    >
      <div className="container mx-auto max-w-6xl px-4">
        <h2
          className="mb-6 text-3xl font-bold"
          style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
        >
          What Happens When I Start a {lenderName} Car Finance Claim?
        </h2>

        <p
          className="mb-8 text-lg leading-relaxed"
          style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
        >
          Once you begin your {lenderName} car finance claim, we&apos;ll quickly
          assess whether you&apos;re eligible for compensation due to a mis-sold
          agreement. If you qualify, we&apos;ll also estimate how much you could
          be entitled to. Here&apos;s what to expect next:
        </p>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {/* Step 1 */}
          <div className="bg-card border-foreground group rounded-lg border-2 p-6 transition-all duration-300 hover:scale-105 hover:shadow-lg">
            <div
              className="text-primary mb-2 text-2xl font-bold"
              aria-label="Step 1"
            >
              Step 1
            </div>
            <div
              className="mb-4 text-xl font-bold"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              Contacting the Lender
            </div>
            <p
              className="leading-relaxed"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              Our partner law firm writes directly to {lenderName} on your
              behalf to start your claim. This formal complaint outlines the
              details of your case and initiates the process.
            </p>
          </div>

          {/* Step 2 */}
          <div className="bg-card border-foreground group rounded-lg border-2 p-6 transition-all duration-300 hover:scale-105 hover:shadow-lg">
            <div
              className="text-primary mb-2 text-2xl font-bold"
              aria-label="Step 2"
            >
              Step 2
            </div>
            <div
              className="mb-4 text-xl font-bold"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              Awaiting a Response
            </div>
            <p
              className="leading-relaxed"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              The lender is expected to respond or acknowledge your complaint
              within a reasonable time. In some cases, this may happen quickly.
            </p>
          </div>

          {/* Step 3 */}
          <div className="bg-card border-foreground group rounded-lg border-2 p-6 transition-all duration-300 hover:scale-105 hover:shadow-lg">
            <div
              className="text-primary mb-2 text-2xl font-bold"
              aria-label="Step 3"
            >
              Step 3
            </div>
            <div
              className="mb-4 text-xl font-bold"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              Delays Allowed by the FCA
            </div>
            <p
              className="leading-relaxed"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              The Financial Conduct Authority (FCA) has given lenders permission
              to pause complaint responses until{' '}
              <strong
                className="font-semibold"
                style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
              >
                early <span className="font-raleway-numbers">2026</span>
              </strong>
              , which means you may not get a final answer straight away.
              However, your claim will still be registered and progressing in
              the background.
            </p>
          </div>

          {/* Step 4 */}
          <div className="bg-card border-foreground group rounded-lg border-2 p-6 transition-all duration-300 hover:scale-105 hover:shadow-lg">
            <div
              className="text-primary mb-2 text-2xl font-bold"
              aria-label="Step 4"
            >
              Step 4
            </div>
            <div
              className="mb-4 text-xl font-bold"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              Submitting Evidence
            </div>
            <p
              className="leading-relaxed"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              We&apos;ll submit all necessary claim evidence on your behalf and
              negotiate with {lenderName} to achieve the best possible outcome
              for you. You won&apos;t need to handle any paperwork or legal
              discussions, we do it all for you.
            </p>
          </div>
        </div>

        <p
          className="mt-8 text-lg leading-relaxed"
          style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
        >
          We&apos;ll keep you informed every step of the way, so you&apos;re
          never left in the dark. Your journey to compensation is in safe hands.
        </p>
      </div>
    </section>
  )
}

export default ClaimProcessSteps
